import React, { Component } from "react";
import { message, Alert, Typography, Space } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  InputNumberItem,
  SelectInsumosItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  FilaHospedajeVenta,
  hospedajeParaPayload,
} from "../../../../../Components/Items";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

const { Text } = Typography;

class EditarRemisionVenta extends Component {
  state = {
    cargando: false,
    guardando: false,
    bloqueado: false,
    motivoBloqueo: null,
    proyectoId: null,
    insumos: [],
    paso: "editar",
    mensajes: [],
    insumoSelectKey: 0,
    nuevoInsumoId: null,
    nuevoInsumoSeleccionado: null,
    nuevoCantidad: 1,
    nuevoPrecio: 0,
    //Hotelería: habitaciones activas con su insumo de tarifa, para poder reasignar la habitación o
    //corregir las fechas de una estancia ya capturada.
    habitacionesHotel: [],
    insumosHospedajeIds: new Set(),
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.cargarDatos();
      if (this.props.moduloHoteleria) this.consultarHabitacionesHotel();
    }
  }

  consultarHabitacionesHotel() {
    axios
      .post(
        "hoteleria/selectHabitacionesParaVenta",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return;
        const habitaciones = res.data.habitaciones || [];
        this.setState({
          habitacionesHotel: habitaciones,
          insumosHospedajeIds: new Set(habitaciones.map((valor) => String(valor.insumoId))),
        });
      })
      .catch((error) => console.error("Error al cargar las habitaciones del hotel:", error));
  }

  cargarDatos() {
    this.setState({
      cargando: true,
      paso: "editar",
      mensajes: [],
      nuevoInsumoId: null,
      nuevoInsumoSeleccionado: null,
      nuevoCantidad: 1,
      nuevoPrecio: 0,
    });
    axios
      .post(
        "ventas/datosEditarRemision",
        { empresaId: this.props.empresaId, ventaId: this.props.ventaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          this.setState({ cargando: false, bloqueado: true, motivoBloqueo: res.data.message || "No se pudo cargar la remisión." });
          return;
        }
        this.setState({
          cargando: false,
          bloqueado: res.data.bloqueado,
          motivoBloqueo: res.data.motivo,
          proyectoId: res.data.proyectoId,
          insumos: (res.data.insumos || []).map((valueInsumo) => ({ ...valueInsumo })),
        });
      })
      .catch(() => {
        this.setState({ cargando: false, bloqueado: true, motivoBloqueo: "Ocurrió un error al cargar la remisión." });
      });
  }

  actualizarLinea(index, campo, valor) {
    const insumos = [...this.state.insumos];
    insumos[index] = { ...insumos[index], [campo]: valor };
    this.setState({ insumos });
  }

  quitarLinea(index) {
    const insumos = [...this.state.insumos];
    insumos.splice(index, 1);
    this.setState({ insumos });
  }

  agregarLinea() {
    if (!this.state.nuevoInsumoId || !this.state.nuevoCantidad) {
      message.warning("Selecciona el insumo y la cantidad a agregar.");
      return;
    }
    const insumo = this.state.nuevoInsumoSeleccionado;
    this.setState({
      insumos: [
        ...this.state.insumos,
        {
          insumoId: this.state.nuevoInsumoId,
          proyectoId: this.state.proyectoId,
          cantidad: this.state.nuevoCantidad,
          precioUnitario: this.state.nuevoPrecio || 0,
          descuento: 0,
          descuentoCantidad: 0,
          entregado: 0,
          clave: insumo?.clave,
          descripcion: insumo?.descripcion,
        },
      ],
      nuevoInsumoId: null,
      nuevoInsumoSeleccionado: null,
      nuevoCantidad: 1,
      nuevoPrecio: 0,
      insumoSelectKey: this.state.insumoSelectKey + 1,
    });
  }

  construirPayloadInsumos() {
    //Esta es una LISTA BLANCA, no un spread del renglón: lo que no se ponga aquí se pierde al
    //guardar. Por eso `hospedaje` tiene que estar —si no, editar el precio de una estancia borraría
    //la habitación y las fechas, y el mapa de hotel la liberaría sola—. La llave se manda solo si el
    //módulo está prendido: el backend distingue null ("bórrala") de la llave ausente ("no la toques"),
    //así que mandarla siempre le pondría un `hospedaje: null` a cada renglón de cada remisión editada
    //de todas las empresas.
    return this.state.insumos.map((valueInsumo) => ({
      _id: valueInsumo._id,
      insumoId: valueInsumo.insumoId,
      proyectoId: valueInsumo.proyectoId,
      cantidad: Number(valueInsumo.cantidad || 0),
      precioUnitario: Number(valueInsumo.precioUnitario || 0),
      precioUnitarioAjustado: Number(valueInsumo.precioUnitario || 0),
      descuento: Number(valueInsumo.descuento || 0),
      descuentoCantidad: Number(valueInsumo.descuentoCantidad || 0),
      leyenda: valueInsumo.leyenda,
      observaciones: valueInsumo.observaciones,
      ...(this.props.moduloHoteleria
        ? { hospedaje: hospedajeParaPayload(valueInsumo.hospedaje) }
        : {}),
    }));
  }

  previsualizar() {
    if (this.state.insumos.length === 0) {
      message.warning("La remisión debe tener al menos un insumo.");
      return;
    }
    this.setState({ guardando: true });
    axios
      .post(
        "ventas/previsualizarEdicionRemision",
        { empresaId: this.props.empresaId, ventaId: this.props.ventaId, insumos: this.construirPayloadInsumos() },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success !== 2) {
          message.error("Ocurrió un error al previsualizar los cambios.");
          return;
        }
        if (res.data.bloqueado) {
          message.error(res.data.motivo || "No se puede editar esta remisión con esos cambios.");
          return;
        }
        this.setState({ paso: "confirmar", mensajes: res.data.mensajes || [] });
      })
      .catch(() => {
        this.setState({ guardando: false });
        message.error("Ocurrió un error al previsualizar los cambios.");
      });
  }

  guardar() {
    this.setState({ guardando: true });
    axios
      .post(
        "ventas/editarRemision",
        { empresaId: this.props.empresaId, ventaId: this.props.ventaId, insumos: this.construirPayloadInsumos() },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ guardando: false });
        if (res.data.success === 2) {
          message.success("Se editó la remisión.");
          NotificacionPolizas(res.data.polizasId);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.props.cerrarEditarRemision(true);
        } else {
          message.error(res.data.message || "Sucedió un error y no se editó la remisión.");
        }
      })
      .catch(() => {
        this.setState({ guardando: false });
        message.error("Sucedió un error y no se editó la remisión.");
      });
  }

  render() {
    const { insumos, paso, mensajes, bloqueado, motivoBloqueo, cargando, guardando } = this.state;

    return (
      <ModalItem
        title="Editar Remisión"
        visible={this.props.visible}
        spinning={cargando || guardando}
        onCancel={() => this.props.cerrarEditarRemision(false)}
        paddingTop
        destroyOnClose
        width="70%"
      >
        {bloqueado ? (
          <Alert type="warning" showIcon message="No se puede editar esta remisión" description={motivoBloqueo} />
        ) : paso === "editar" ? (
          <>
            <Alert
              type="info"
              showIcon
              style={{ marginBottom: 15 }}
              message="Edita cantidades, precio y descuento, o agrega/quita insumos. Antes de guardar se te mostrará exactamente qué va a pasar (inventario, pólizas, pedido/cotización de origen)."
            />
            {insumos.map((valueInsumo, index) => (
              <div
                key={valueInsumo._id || `nuevo-${index}`}
                style={{ marginBottom: 10, borderBottom: "1px solid #eee", paddingBottom: 10 }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ flex: 2 }}>
                    <Text strong>
                      {valueInsumo.clave ? valueInsumo.clave + " - " : ""}
                      {valueInsumo.descripcion}
                    </Text>
                    {valueInsumo.entregado > 0 ? (
                      <div>
                        <Text type="secondary" style={{ fontSize: 12 }}>Ya entregado: {valueInsumo.entregado}</Text>
                      </div>
                    ) : null}
                  </div>
                  <div style={{ flex: 1 }}>
                    <InputNumberItem min={0} value={valueInsumo.cantidad} placeholder="Cantidad" onChange={(v) => this.actualizarLinea(index, "cantidad", v)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <InputNumberItem min={0} value={valueInsumo.precioUnitario} placeholder="Precio unitario" dinero onChange={(v) => this.actualizarLinea(index, "precioUnitario", v)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <InputNumberItem min={0} max={100} value={valueInsumo.descuento} placeholder="Descuento %" onChange={(v) => this.actualizarLinea(index, "descuento", v)} />
                  </div>
                  <ButtonItem rojoB icon={<DeleteOutlined />} onClick={() => this.quitarLinea(index)} />
                </div>

                {/* Hospedaje: solo en los renglones cuyo insumo es el de alguna habitación del hotel.
                    Al cambiar las fechas se actualiza también la cantidad, que en hospedaje es el
                    número de noches. */}
                {this.props.moduloHoteleria &&
                  this.state.insumosHospedajeIds.has(String(valueInsumo.insumoId)) && (
                    <div style={{ marginTop: 8, paddingLeft: 4 }}>
                      <FilaHospedajeVenta
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        ventaId={this.props.ventaId}
                        proyectoId={this.state.proyectoId}
                        habitaciones={this.state.habitacionesHotel}
                        insumoId={valueInsumo.insumoId}
                        value={valueInsumo.hospedaje}
                        onChange={(valor) => this.actualizarLinea(index, "hospedaje", valor)}
                        onNochesChange={(noches) => this.actualizarLinea(index, "cantidad", noches)}
                      />
                    </div>
                  )}
              </div>
            ))}

            <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 15 }}>
              <div style={{ flex: 2 }}>
                <SelectInsumosItem
                  key={this.state.insumoSelectKey}
                  empresaId={this.props.empresaId}
                  headersToken={this.props.headersToken}
                  tiposInsumos="inventariables"
                  width="100%"
                  placeholder="Agregar insumo..."
                  onChange={(value, insumo) => this.setState({ nuevoInsumoId: value, nuevoInsumoSeleccionado: insumo })}
                />
              </div>
              <div style={{ flex: 1 }}>
                <InputNumberItem min={0} value={this.state.nuevoCantidad} placeholder="Cantidad" onChange={(v) => this.setState({ nuevoCantidad: v })} />
              </div>
              <div style={{ flex: 1 }}>
                <InputNumberItem min={0} value={this.state.nuevoPrecio} placeholder="Precio unitario" dinero onChange={(v) => this.setState({ nuevoPrecio: v })} />
              </div>
              <ButtonItem type="primary" icon={<PlusOutlined />} onClick={this.agregarLinea.bind(this)}>
                Agregar
              </ButtonItem>
            </div>

            <ButtonItem type="primary" style={{ display: "block", margin: "20px 0 0 auto" }} onClick={this.previsualizar.bind(this)}>
              Previsualizar Cambios
            </ButtonItem>
          </>
        ) : (
          <>
            <Alert
              type="warning"
              showIcon
              message="Esto es lo que va a pasar al guardar:"
              description={
                <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
                  {mensajes.map((valueMensaje, index) => (
                    <li key={index}>{valueMensaje}</li>
                  ))}
                </ul>
              }
            />
            <Space style={{ marginTop: 20, display: "flex", justifyContent: "flex-end" }}>
              <ButtonItem onClick={() => this.setState({ paso: "editar" })}>Regresar</ButtonItem>
              <ButtonItem type="primary" verdeB onClick={this.guardar.bind(this)}>
                Confirmar y Guardar
              </ButtonItem>
            </Space>
          </>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    moduloHoteleria: state.empresa.moduloHoteleria,
  };
};

export default connect(mapStateToProps)(EditarRemisionVenta);
